import { FC } from 'react';

import { ProcessedDepressionData } from 'models/DepressionScreening';

import { DepressionScreeningHeader } from './DepressionScreeningHeader';
import { DepressionScreeningView } from './DepressionScreeningView';

type DepressionScreeningContentProps = {
  depressionData: ProcessedDepressionData;
  isExpanded: boolean;
};

export const DepressionScreeningContent: FC<DepressionScreeningContentProps> = ({
  depressionData,
  isExpanded
}) => (
  <>
    <DepressionScreeningHeader depressionData={depressionData} isExpanded={isExpanded} />
    <DepressionScreeningView depressionData={depressionData} isExpanded={isExpanded} />
  </>
);
